

$(function () {
  let slider = ".mv_slider";
  let $bar = $('.bar');
  if ($(slider).length < 1) { return; }

  $(slider).on('init', function (slick) {
    $bar.animate({ width: '100%' }, 2900);
    setTimeout(function () {
      $('.mv_slider li:first-of-type a').css({ 'background-size': '110% auto' })
    }, 0);
  })
  $(slider).slick({
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1200,
    arrows: false,
    dots: false,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    // centerMode: true,
    // dotsClass: 'mainslider__dots__in',
    // appendDots: $('.mainslider__dots'),
    // slidesToShow: 1,
    // centerMode: true, //要素を中央寄せ
    // asNavFor: '.thumbnail_text'
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $bar.css({ width: '0%' }).animate({ width: '100%' }, 2900);
    $.when(
      $(slider + ' li[data-slick-index="' + nextSlide + '"] a').css({ 'background-size': '100% auto' })
    ).done(function () {
      $(slider + ' li[data-slick-index="' + nextSlide + '"] a').css({ 'background-size': '110% auto' })
    });
  }).on('afterChange', function (event, slick, currentSlide) {
    $(slider + ' li[data-slick-index="' + (currentSlide - 1) + '"] a').css({ 'background-size': '100% auto' })
  });



  let sliderSp = ".mv_slider--sp";
  let $barSp = $('.bar--sp');
  if ($(sliderSp).length < 1) { return; }

  $(sliderSp).on('init', function (slick) {
    $barSp.animate({ width: '100%' }, 1900);
    setTimeout(function () {
      $('.mv_slider li:first-of-type a').css({ 'background-size': '110% auto' })
    }, 0);
  })
  $(sliderSp).slick({
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1200,
    arrows: false,
    dots: false,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    // centerMode: true,
    // dotsClass: 'mainslider__dots__in',
    // appendDots: $('.mainslider__dots'),
    // slidesToShow: 1,
    // centerMode: true, //要素を中央寄せ
    // asNavFor: '.thumbnail_text'
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $barSp.css({ width: '0%' }).animate({ width: '100%' }, 2900);
    $.when(
      $(sliderSp + ' li[data-slick-index="' + nextSlide + '"] a').css({ 'background-size': '100% auto' })
    ).done(function () {
      $(sliderSp + ' li[data-slick-index="' + nextSlide + '"] a').css({ 'background-size': '110% auto' })
    });
  }).on('afterChange', function (event, slick, currentSlide) {
    $(sliderSp + ' li[data-slick-index="' + (currentSlide - 1) + '"] a').css({ 'background-size': '100% auto' })
  });
});